// data providers
import PageProvider from '../shared/providers/PageProvider';
import TabFetchProvider from '../shared/providers/TabFetchProvider';
import TabProvider from '../shared/providers/TabProvider';

// page and index tab
import HorsePage from './HorsePage';
import IndexTab from './IndexTab';

// common horse tabs
import Form from './form/Form';
import Entries from '../shared/entries/Entries';
import Stats from './stats/Stats';
import Quotes from './quotes/Quotes';
import Pedigree from './pedigree/Pedigree';
import Sales from './sales/Sales';
import Notes from './notes/Notes';

// progeny present on stallion and dam
import Progeny from './progeny/Progeny';

// dam tabs
import ProgenyEntries from './progenyEntries/ProgenyEntries';
import ProgenySales from './progenySales/ProgenySales';

// stallion tabs
import WeatherbysOverview from './weatherbysOverview/WeatherbysOverview';
import SireReference from './sireReference/SireReference';
import RecentStakesPerformers from './recentStakesPerformers/RecentStakesPerformers';
import ProgenyStatistics from './progenyStatistics/ProgenyStatistics';
import SalesStatistics from './salesStatistics/SalesStatistics';
import FeeHistory from './feeHistory/FeeHistory';
import Nicks from './nicks/Nicks';
import ProgenyResults from './progenyResults/ProgenyResults';
import SalesResults from './salesResults/SalesResults';
import SalesEntries from './salesEntries/SalesEntries';
import BestProgeny from './bestProgeny/BestProgeny';
import StallionBookPdf from './stallionBookPdf/StallionBookPdf';


const childRoutes = [
    // common horse tabs
    { path: 'form', Tab: Form, childRoutes: [{ path: 'my-ratings' }] },
    { path: 'entries', Tab: Entries },
    { path: 'stats', Tab: Stats },
    { path: 'quotes', Tab: Quotes },
    { path: 'pedigree', Tab: Pedigree },
    { path: 'sales', Tab: Sales },
    { path: 'notes', Tab: Notes },

    // progeny present on stallion and dam
    { path: 'progeny', Tab: Progeny },

    // dam tabs
    { path: 'progeny-entries', Tab: ProgenyEntries },
    { path: 'progeny-sales', Tab: ProgenySales },

    // stallion tabs
    { path: 'weatherbys-overview', Tab: WeatherbysOverview },
    { path: 'best-progeny', Tab: BestProgeny },
    { path: 'sire-reference', Tab: SireReference },
    { path: 'recent-stakes-performers', Tab: RecentStakesPerformers },
    { path: 'stallion-book-pdf', Tab: StallionBookPdf },
    { path: 'progeny-dams-sire', Tab: Progeny },
    { path: 'progeny-statistics', Tab: ProgenyStatistics },
    { path: 'progeny-results', Tab: ProgenyResults },
    { path: 'nicks', Tab: Nicks },
    { path: 'fee-history', Tab: FeeHistory },
    { path: 'sales-statistics', Tab: SalesStatistics },
    { path: 'sales-results', Tab: SalesResults },
    { path: 'sales-entries', Tab: SalesEntries },
];

const noFetchTabs = ['entries', 'sales-results', 'sales-entries'];

const routes = {
    path: 'horse/:id/:name',
    component: PageProvider,
    Page: HorsePage,
    indexRoute: { component: IndexTab },
    childRoutes: childRoutes.map(route => ({
        ...route,
        component: noFetchTabs.includes(route.path) ?
            TabProvider : TabFetchProvider,
    })),
};


export default routes;



// WEBPACK FOOTER //
// ./src/js/horse/horseRoutes.js